import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BasedataService } from "../../shared/basedata.service";
import { Pin } from "./pin.interface";
import { BpConfigService } from "../../config/bp-config.service";
import { CoClientModeService } from "../../config/co-client-mode.service";

@Injectable()
export class PinApiService extends BasedataService {

  constructor(
    private http: HttpClient,
    configService: BpConfigService,
    private readonly coClientModeService: CoClientModeService
  ) {
    super(configService);
  }

  updatePin(pin: Pin, updatePin: Pin): Observable<Pin> {
    return this.http.patch<Pin>(`${this.getFullUrl('pins')}/${pin.id}`, updatePin);
  }

  getBimPins(): Observable<Pin[]> {
    return this.http.get<Pin[]>(this.getFullUrl('pins'), { params: this.getPinParams('bim') });
  }

  private getPinParams(pointType: string): { [param: string]: string | boolean } {
    return this.coClientModeService.isCentralCoClient()
      ? { pointType, allPins: true }
      : { pointType };
  }
}
